import { useQueryClient } from "@tanstack/react-query";
import type { FunctionComponent } from "react";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import { PROJECT_QUERY_KEY } from "~/modules/project/api/project/projectQueries.ts";
import { PROJECTS_PHASES_QUERY_KEY } from "~/modules/project/api/projectPhase/projectPhaseQueries.ts";
import { PROJECTS_STAFFINGS_QUERY_KEY } from "~/modules/project/api/staffing/staffingQueries.ts";
import UpdateProjectPhaseStatusForm
	from "~/modules/project/components/ProjectDetailsView/components/UpdateProjectPhaseStatusForm";

type UpdateProjectPhaseStatusSidebarProps = {
	currentPhaseStatusId: string;
	isOpen: boolean;
	phaseHasTimeTrackings: boolean;
	projectId: string;
	projectPhaseId: string;
	onClose: (open: boolean) => void;
};

const UpdateProjectPhaseStatusSidebar: FunctionComponent<UpdateProjectPhaseStatusSidebarProps> = ({
	currentPhaseStatusId,
	isOpen,
	phaseHasTimeTrackings,
	projectId,
	projectPhaseId,
	onClose,

}) => {
	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async (newStatusId: string) => {
		queryClient.invalidateQueries({ queryKey: PROJECT_QUERY_KEY(projectId) });
		if (["3", "4", "5"].includes(newStatusId)) {
			queryClient.invalidateQueries({ queryKey: PROJECTS_STAFFINGS_QUERY_KEY(projectId) });
		}
		await queryClient.invalidateQueries({ queryKey: PROJECTS_PHASES_QUERY_KEY(projectId) });
		onClose(false);
	}, [queryClient, projectId, onClose]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 width="md"
				 open={isOpen}
				 setOpen={() => onClose(!isOpen)}>
			<UpdateProjectPhaseStatusForm
				currentStatusId={currentPhaseStatusId}
				onSuccess={handleSuccess}
				onCancel={() => onClose(false)}
				phaseHasTimeTrackings={phaseHasTimeTrackings}
				projectId={projectId}
				projectPhaseId={projectPhaseId}
			/>
		</Sidebar>
	);
};

export default UpdateProjectPhaseStatusSidebar;
